import { useMutation, MutationOptions } from 'react-query';
import UnitService from '../../../services/unitService';

const useUpdateUnitMutation = ({
  propertyId,
  organizationId,
  unitId,
  options,
}: {
  propertyId: string,
  organizationId: string,
  unitId: string,
  options: MutationOptions,
}) => {
  return useMutation((data) => {
    const unitService = new UnitService();
    return unitService.updateUnit(propertyId, organizationId, unitId, data);
  }, options);
};

export default useUpdateUnitMutation;
